<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="card">
    <div class="card-media">
      <VideoPlayer v-if="card.media.type === 'video'" :media-url="card.media.url" :label="card.media?.alt || ''" not-rounded />
      <YouTubeEmbedd
        v-else-if="card.media.type === 'youtube'"
        :youtube-url="card.media.url"
        not-rounded
      />
      <ImageElement
        v-else-if="card.media.type === 'image'"
        :src="card.media.url"
        :alt="card.media?.alt || ''"
        not-rounded
        aspect-ratio="2.35 / 1"
        :allow-download="false"
      />
    </div>
    <div class="card-body">
      <h1>{{ card.headline }}</h1>
      <p>{{ card.text }}</p>
    </div>
    <div class="card-actions">
      <MessageButton
        v-for="(button, index) in getActions"
        :key="index"
        :button="button"
        variant="card"
        source="card"
        @on-intent="($event) => $emit('onIntent', $event)"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import VideoPlayer from "@/components/media/VideoPlayer.vue";
import YouTubeEmbedd from "@/components/media/YouTubeEmbedd.vue";
import { computed } from "vue";
import MessageButton from "@/components/messages/MessageButton/MessageButton.vue";
import type { Card } from "@/services/bot/messageBuilder";
import type { Intent } from "@/types";
import ImageElement from "@/components/media/ImageElement.vue";

const props = defineProps<{
  card: Card;
}>();

defineEmits<{
  onIntent: [intent: Intent];
}>();

const getActions = computed(() => props.card.actions);
</script>

<style lang="scss" scoped>
.card {
  display: grid;
  background: var(--moin-message-card-background, #ffffff);
  width: 100%;
  grid-template-rows: auto 1fr auto;
  grid-template-rows: subgrid;
  grid-row: span 3;
  border-radius: var(--kw-widget-global-borderradius-outer);
  border-color: var(--moin-message-carouselcard-bordercolor, transparent);
  overflow: hidden;
  padding-bottom: 15px;
  margin-top: 0px;

  .card-media {
    pointer-events: all;
    cursor: grab;
    aspect-ratio: 2.35 / 1;
    width: 100%;
  }

  .videoplayer {
    height: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.card-body {
  padding: 0 15px;
  align-self: start;
  padding-top: 10px;

  h1,
  h2,
  h3 {
    margin: 5px 0;
    color: black;
    @include font_headline;
    font-weight: 500;
  }

  p {
    margin-top: 0;
  }
}

.card-actions {
  display: flex;
  padding: 0 15px;
  flex-direction: column;
  justify-content: flex-end;
  gap: 7px;
}
</style>
